<template>
  <el-table-column :prop="prop" :label="label" :width="width" align="center"
                   v-bind="$attrs" v-on="$listeners">
    <template v-slot="{row}">
      <i class="fa fa-check-circle color-success" v-if="row[prop]"/>
      <i class="fa fa-ban color-gray" v-else></i>
    </template>
  </el-table-column>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  components: {},
  extends: BaseVue,
  props: {
    prop: {
      type: String,
      default: "valid"
    },
    label: {
      type: String,
      default: "有效"
    },
    width: {
      type: String,
      default: "50"
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
@import "@/css/variables";
</style>